// frontend/main.mjs - Ultra-simplified entry point

import "./components/player.mjs";
import AudioPrimer from "./util/audio-primer.mjs";
import TrackPlayerSPA from "./spa.mjs";

console.log("imported components/player.mjs");

// Initialize the Single Page Application (handles audio unlocking internally)
const spa = new TrackPlayerSPA();

// Expose globally for debugging
window.trackPlayerSPA = spa;
window.AudioPrimer = AudioPrimer;

console.log("Main app initialized with ultra-simple audio handling");

// Debug helpers
if (window.location.search.includes('debug=true')) {
    window.debug = {
        spa: () => window.trackPlayerSPA,
        isAudioReady: () => window.trackPlayerSPA.isAudioReady,
        isUnlocked: () => AudioPrimer.isUnlocked,
        needsUnlocking: () => AudioPrimer.needsUnlocking(),
        
        // SPA helpers
        getCurrentTrack: () => window.trackPlayerSPA?.getCurrentTrack(),
        setTrack: (name) => window.trackPlayerSPA?.setTrack(name)
    };
    
    console.log('Debug mode enabled. Try: debug.isUnlocked(), debug.setTrack("trackname")');
}
